import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Footer } from "./components/footer/Footer";
import "./App.scss";

import { Contactus } from "./pages/Contactus";
import { Opportunities } from "./pages/Opportunities";
import { JobDescription } from "./pages/JobDescription";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Contactus />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/opportunities/:jobId" element={<JobDescription />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
